export const zoneColumns = [
  {
    dataField: 'name',
    text: 'zone.name',
    disableSort: true,
  },
  {
    dataField: 'description',
    text: 'zone.description',
    disableSort: true,
  },
  {
    dataField: 'type',
    text: 'zone.type',
    disableSort: true,
  },
  {
    dataField: 'capacity',
    text: 'zone.capacity',
    disableSort: true,
  },
  {
    dataField: 'season',
    text: 'zone.season',
    disableSort: true,
  },
  {
    dataField: 'time_start',
    text: 'zone.time_start',
    disableSort: true,
  },
  {
    dataField: 'time_end',
    text: 'zone.time_end',
    disableSort: true,
  },
];
